import { api } from '../../api';
import ConfigListManager from '../../components/ConfigListManager';

export default function ComplianceCategoriesPage() {
  return (
    <div style={{ padding: '24px' }}>
      <ConfigListManager
        title="Compliance Categories"
        fetchFn={api.getComplianceCategories}
        createFn={api.createComplianceCategory}
        updateFn={api.updateComplianceCategory}
        deleteFn={api.deleteComplianceCategory}
        extraFields={[
          { key: 'description', label: 'Description', type: 'text', defaultValue: '' },
          { key: 'sort_order', label: 'Sort Order', type: 'text', defaultValue: '0' },
        ]}
      />
    </div>
  );
}
